// The events API's calls for members (B2; D33), for the Events tab: every answer read with the
// schema @grc/shared gives it (anything else is `unexpected`), the answer sent as JSON (D21).
import {
  EventResponse,
  EventsResponse,
  PastEventsResponse,
  type EventDetail,
  type EventView,
  type RsvpAnswer,
  type RsvpRequest,
} from '@grc/shared';
import { getJson, postJson, readAs } from '../../api';

const EVENTS = '/api/events';

/** An event's route, and the action after it. */
function eventPath(id: string, action = ''): string {
  return `${EVENTS}/${encodeURIComponent(id)}${action}`;
}

/** Every event not over yet, soonest first, the cancelled ones among them. */
export async function upcomingEvents(): Promise<EventView[]> {
  return (await readAs(EventsResponse, getJson(`${EVENTS}/upcoming`))).events;
}

/**
 * A page of the events that are over, newest first: the first, or the one before the event
 * `before` (the last of the page before), and whether there are more.
 */
export function pastEvents(before?: string): Promise<PastEventsResponse> {
  const page = before === undefined ? '' : `?before=${encodeURIComponent(before)}`;
  return readAs(PastEventsResponse, getJson(`${EVENTS}/past${page}`));
}

/** An event's page: the event, and who said yes and who said maybe. */
export async function eventPage(id: string): Promise<EventDetail> {
  return (await readAs(EventResponse, getJson(eventPath(id)))).event;
}

/** The member's answer, until the event starts; the event's page as it is then. */
export async function answerEvent(id: string, answer: RsvpAnswer): Promise<EventDetail> {
  const body: RsvpRequest = { answer };
  return (await readAs(EventResponse, postJson(eventPath(id, '/rsvp'), body))).event;
}
